var components;
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.status)?_c('v-uni-view',{staticClass:"load"},[_vm._v(" "+_vm._s(_vm.$t("正在加载中"))+" ")]):_vm._e()}
var recyclableRender = false
var staticRenderFns = []

export { render, staticRenderFns, recyclableRender, components }